import { useEffect, useState } from "react";

const navLinks = [
  { label: "平台介绍", href: "#features" },
  { label: "分类指南", href: "#genres" },
  { label: "画风解析", href: "#styles" },
  { label: "题材推荐", href: "#recommend" },
  { label: "阅读指南", href: "#reading" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-[68px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer shrink-0">
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/20 text-background-50"
            }`}
          >
            <i className="ri-book-2-line text-xl"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            漫蛙
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 text-sm rounded-md cursor-pointer transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  : "text-background-50/90 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href="#genres"
          className="hidden lg:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          <i className="ri-compass-3-line"></i>
          开始定位
        </a>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm rounded-md text-foreground-700 cursor-pointer hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#genres"
              onClick={() => setOpen(false)}
              className="mt-1 px-3 py-2.5 text-sm rounded-md bg-primary-500 text-background-50 text-center font-medium cursor-pointer"
            >
              开始定位
            </a>
          </div>
        </div>
      )}
    </header>
  );
}